import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection, limit, documentId } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import Loadingimg from "../components/loadingimg";
//page links        
import Header from '../master_root/header';
import { NumberFormatter } from '../components/numberFormatter';
// Icons 
import { MdKeyboardHide } from 'react-icons/md';
import { BiChat } from 'react-icons/bi';
import { VscCalendar } from "react-icons/vsc";
import { GetCalculateAge } from '../components/calculateAge';
import Photosicon from '../assets/photos_icon.png';
import { MdOutlinePayments } from "react-icons/md";
import { GetAgoTime } from '../components/getAgoTime';
import { CiBookmarkCheck, CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoBusinessOutline, IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
//page links    
import Navbar from '../master_root/Navbar';
import { FaUser } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import { MdOutlineManageSearch, MdOutlineCategory } from "react-icons/md";
import { FaHandsHelping } from "react-icons/fa";
import './home.css';
import '../components/fetchfategorie_ui.css';
import Footer from '../master_root/footer';
import WhatsAppQueryPopup from '../components/WhatsAppQueryPopup'; 
//dashboard
import Dashboard from '../dashboard_root/dashboard';
import { PiArrowSquareDownLight, PiArrowSquareUpLight } from "react-icons/pi";
export default function Home() {
  const [loading, setLoading] = useState(true);
  const [Skillscategories, setSkillscategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [Jobtasks, setJobtasks] = useState([]);
  const [CompanysUi, setCompanysUi] = useState([]);
  const [jobcategories, setJobcategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [experience, setExperience] = useState("");
  const [location, setLocation] = useState("");
  const [FetchCategories, setFetchCategories] = useState([]);

  const navigate = useNavigate();
  const [guid, setGuid] = useState("");
  const [homehidedata, sethomehidedata] = useState(true);
  const [loginisOpen, setLoginIsOpen] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
 
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setGuid(existingUser);
      setLoginIsOpen(true);
    } else {
      setLoginIsOpen(false);
    }
  }, []);
  //skills_categories  
  useEffect(() => {
    const fetchSkillscategoriesData = async () => {
      try {
        const jq = query(
          collection(db, "postdata"),
          where("visibility", "==", true)
        );
        const querySnapshot = await getDocs(jq);
        // Step 1: Count posts by skillsId
        const skillsCountMap = {};
        const skillIdsSet = new Set();

        querySnapshot.docs.forEach(doc => {
          const skillId = doc.data().skillsId;
          if (skillId) {
            skillIdsSet.add(skillId);
            skillsCountMap[skillId] = (skillsCountMap[skillId] || 0) + 1;
          }
        });

        // Step 2: Fetch skills data using collected skill IDs
        const skillIdsArray = Array.from(skillIdsSet);
        const skillCategoriesPromises = skillIdsArray.map(async skillId => {
          const q = query(
            collection(db, "skills_categories"),
            where("skillsId", "==", skillId)
          );
          const skillSnap = await getDocs(q);
          const skillDoc = skillSnap.docs[0];
          return {
            id: skillDoc?.id,
            ...skillDoc?.data(),
            totalPosts: formatCount(skillsCountMap[skillId]) || 0
          };
        });

        const skillscategoriesList = await Promise.all(skillCategoriesPromises);
        setSkillscategories(skillscategoriesList);
        setIsLoading(false);

      } catch (error) {
        console.error("Error fetching job categories:", error);
        setIsLoading(false);
      }
    };
 
      fetchSkillscategoriesData();
 


  }, []);
  const formatCount = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + "K";
    return num.toString();
  };
  //companys-ui-grid
  useEffect(() => {
    const fetchcompanys = async () => {
      try {
        const q = query(
          collection(db, "companys"),
          where("status", "==", true)
        );
        const companysSnapshot = await getDocs(q);
        const companysList = companysSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setCompanysUi(companysList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching companys:", error);
        setIsLoading(false);
      }
    };
 
      fetchcompanys();
 
  }, []);
  //Jobtasks
  const [UsersData, setUsersData] = useState([]);
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        const q = query(
          collection(db, "postdata"),
          where("visibility", "==", true)
        );
        const querySnapshot = await getDocs(q);

        const JobtasksList = await Promise.all(
          querySnapshot.docs.map(async doc => {
            const jobData = { id: doc.id, ...doc.data() };

            // Fetch corresponding company data
            const cq = query(
              collection(db, "companys"),
              where("uid", "==", jobData.companysuid),
              where("status", "==", true)
            );
            const companysSnapshot = await getDocs(cq);
            const companyData = companysSnapshot.docs.map(cdoc => ({
              id: cdoc.id,
              ...cdoc.data()
            }))[0]; // Assuming only one company per job

            return {
              ...jobData,
              company: companyData || null
            };
          })
        );

        setJobtasks(JobtasksList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching Jobtasks:", error);
        setIsLoading(false);
      }
    };
 
      fetchJobtasks();
 
  }, []);
  //categories list 

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const q = query(
          collection(db, "skills_categories"),
          where("status", "==", true)
        );
        const querySnapshot = await getDocs(q);

        const categoriesList = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const skillsData = { id: doc.id, ...doc.data() };

            let jobcatData = [];

            if (skillsData.skillsId) {
              const cq = query(
                collection(db, "jobcategories"),
                where("skillsId", "==", skillsData.skillsId),
                where("status", "==", true)
              );
              const jobcatSnapshot = await getDocs(cq);
              jobcatData = jobcatSnapshot.docs.map((cdoc) => ({
                id: cdoc.id,
                ...cdoc.data(),
              }));
            }

            return {
              skillsData,
              jobcat: jobcatData,
            };
          })
        );

        setFetchCategories(categoriesList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setIsLoading(false);
      }
    };
 
      fetchCategories();
   

  }, []);
  const [feedsData, setFeedsData] = useState([]);

  const fetchsetFeedsData = async () => {
    try {
      const feedsQuery = query(
        collection(db, "feeddata"),
        where("public", "==", true),
        where("status", "==", true),
        limit(6)
      );
      const feedsSnapshot = await getDocs(feedsQuery);



      const dataList = await Promise.all(
        feedsSnapshot.docs.map(async (doc) => {
          const feedData = { id: doc.id, ...doc.data() };

          const detailsQuery = query(
            collection(db, "users"),
            where("guid", "==", feedData.guid)
          );

          const detailsSnapshot = await getDocs(detailsQuery);
          const userData =
            detailsSnapshot.docs.map((detailsDoc) => ({
              uid: detailsDoc.id,
              ...detailsDoc.data(),
            }))[0] || null;

          return {
            ...feedData, // fixed from feedData to usersData
            userData: userData,
          };
        })
      );

      setFeedsData(dataList);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    if (!searchKeyword && !location) {
      alert("Please enter some filters to search.");
      return;
    }
    console.log("Searching with:", { searchKeyword, experience, location });
    // You can navigate or filter based on this
  };
  //user

  const fetchUsers = async () => {
    setIsLoading(true);
    console.log("Fetching users...");

    try {
      const q = query(
        collection(db, "users"),
        where("status", "==", true),
        where("jobseeker", "==", true),
        limit(8)
      );
      const querySnapshot = await getDocs(q);

      console.log("Users found:", querySnapshot.docs.length);

      const usersLoginList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const usersWithFollowers = await Promise.all(
        usersLoginList.map(async user => {
          // Fetch user details
          const detailsQuery = query(
            collection(db, "users_details"),
            where("guid", "==", user.guid)
          );
          const detailsSnapshot = await getDocs(detailsQuery);
          const userDetails = detailsSnapshot.docs.map(doc => doc.data());

          return {
            ...user,
            details: userDetails
          };
        })
      );

      setUsersData(usersWithFollowers);
      console.log("Users with followers:", usersWithFollowers);
    } catch (error) {
      console.error("Error fetching users or followers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function limitStringLength(str, maxLength) {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + " ..."; // truncate
    }
    return str;
  }
  useEffect(() => {
   
      fetchsetFeedsData();
      fetchUsers();
    
  }, []);
  useEffect(() => {
    const existingUser = Cookies.get("homehide");

    if (existingUser !== undefined) {
      // Set initial state from cookie
      const currentValue = existingUser === "true";
      sethomehidedata(currentValue);
    } else {
      // If cookie doesn't exist, default to false (or true, depending on your preference)
      sethomehidedata(false);
      Cookies.set("homehide", "false", { expires: 365 });
    }
  }, []);

  // Toggle function (call on button click etc.)
  const homehide = () => {
    const existingUser = Cookies.get("homehide");

    if (existingUser !== undefined) {
      const currentValue = existingUser === "true";
      const newValue = !currentValue;

      sethomehidedata(newValue);
      Cookies.set("homehide", newValue.toString(), { expires: 365 });
    } else {
      // If the cookie doesn't exist, set it to true
      sethomehidedata(true);
      Cookies.set("homehide", "true", { expires: 365 });
    }
  };

  return (
    <div >
      <Header />
      <div className='app_header_height'></div>

      <Helmet>
        <title>EditorTask - India`s Trusted Platform for Jobs & Creative Talent</title>

        <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India." />
        <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent" />
        <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

      </Helmet>
      <div className="container_roots">
        <div className="container_size">
          {/* {userlogin == true && (
            <>
              {homehidedata == true && (
                <PiArrowSquareDownLight onClick={homehide} className='MdKeyboardHide' />

              )}
              {homehidedata == false && (
                <PiArrowSquareUpLight onClick={homehide} className='MdKeyboardHide' />
              )}

              <br />
              <Dashboard />
            </>
          )} */}
     
              <div className="title-body">

                <div className="title-home">Hire Editors, Get Tasks Done</div>
                <div className="sub-title-home">EditorTask connects job seekers and employers in one smart platform.</div>
                <div className="typing-master-body"><a className="typing-master-home" href='/typing-master'>Typing Master Online Free</a></div>

              </div>

              <div className="search-div">
                <CiSearch className="search-icon" />
                <input
                  className="home-search-input"
                  placeholder="Search Jobs / Tasks / Companies"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
                <input
                  className="experience-search-input"
                  placeholder="Select Experience"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />
                <IoIosArrowDown className="ArrowDown-icon" />
                <input
                  className="location-search-input"
                  placeholder="Location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
                <div className="button-ui" onClick={handleSearch}><CiSearch className='icon' />Search</div>
              </div>

              {loginisOpen == false && (
                <>
                  <br />
                  <div className='button-body'>

                    <a href="/create-job-profile" className="button-ui homebtn">
                      <BsPersonWorkspace className='icon' /> Create Job profile
                    </a>

                    <a href="/create-company-profile" className="button-ui homebtn">
                      <IoBusinessOutline className='icon' /> Create Company
                    </a>
                  </div>

                </>
              )}
              <br />

              <br />

              {/* Browse skillscategories*/}
              <div className='job-categories-body'>

                <div className="header-title-text">Browse Sklls Categories</div>
                <div className="categories-grid">
                  {isLoading ? (
                    <Lodinging />
                  ) : (
                    <>
                      {Skillscategories.map((cat, index) => (
                        <div onClick={() => navigate(`/${cat.slug}`)}
                          className="categories" key={index}>
                          <div className='title-text '

                            style={{ cursor: 'pointer' }}
                          >
                            {cat.title || cat.skillsId} <a className='count-text'>({cat.totalPosts})</a>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
              <br /><br /><br /> <br />
              {/* companys-ui-grid */}
              <div className='companys-body'>
                <div className='job-info'>
                  <div className="header-title-text">Jobs you may be interested in</div>
                </div>
                <div className="companys-ui-grid">
                  {isLoading ? (
                    <Lodinging />
                  ) : (
                    (() => {
                      let lastType = null;
                      return CompanysUi.map((companyuilist, index) => {
                        return (

                          <div
                            className="companys-ui-items"
                            onClick={() => navigate(`/${companyuilist.slug}`)}
                            style={{ cursor: 'pointer' }}
                          >
                            <img
                              className="company-logo"
                              src={companyuilist.icon}
                              alt="Logo"
                              onLoad={() => setLoading(false)}
                              onError={() => setLoading(false)} // also hides loader if there's an error
                              style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                            />
                            <div className='items-box'>
                              <div className="items-name">{companyuilist.companyname}</div>
                              <div className="items-hiring"><FaStar className='items-rating' />{companyuilist.rating + "  |  " + companyuilist.reviws + " reviews"}</div>
                            </div>
                            <div className='industry-box'>
                              {companyuilist.industry && (
                                <div className="home-industry-grid">
                                  {companyuilist.industry.split(',').map((item, index) => (
                                    <div key={index} className="items-industry">
                                      {item.trim()}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            <div className='center-container'>
                              <div className='button-ui'> <IoIosArrowForward className='icon' /> More</div>
                            </div>
                          </div>

                        );
                      });
                    })()
                  )}
                </div>
              </div>
              <br /><br />
              {/* Featured Jobs Or Tasks  */}
              <div className="Featured-Jobs-Or-Tasks">
                <div className='job-info'>
                  <div className="header-title-text">Find Freelance Jobs and Creative Work Opportunities</div>

                </div>
                <div className="Tasks-grid">
                  {isLoading ? (
                    <Lodinging />
                  ) : (
                    Jobtasks.map((Jobtask, index) => (
                      <div
                        key={index}
                        className="Tasks-items"
                      >
                        {Jobtask.company && (
                          <div className="company-hiring" onClick={() => navigate(`/${Jobtask.slug}`)}>

                            <div className='hir-div'>
                              <div className="title-text">{Jobtask.jobcategories}</div>
                              <div className='hir-info-div'>
                                <b className='company'>{Jobtask.company.companyname}</b>
                                <div className='items-box'>
                                  <FaStar className='items-rating' />
                                  <a className='reviews'>
                                    {Jobtask.company.rating + " | " + Jobtask.company.reviws + " reviews"}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className='hir-logo-div'>
                              <img
                                className="hir-logo-img"
                                src={Jobtask.company.logo}
                                alt="Logo"
                                onLoad={() => setLoading(false)}
                                onError={() => setLoading(false)} // also hides loader if there's an error
                                style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                              />
                            </div>
                          </div>
                        )}
                        <div className='job-info-body' onClick={() => navigate(`/${Jobtask.slug}`)}>
                          <div className='job-info'>

                            <table className='experience-table'>
                              <tr><td>
                                <RiSlideshowLine className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='Jobtask-category-text'> {Jobtask.category.replace(/-/g, " ")}</a>
                                </td>
                              </tr>
                              <tr><td>
                                <LuBriefcaseBusiness className='job_biz_icon' />
                              </td>
                                <td>
                                  <a> {Jobtask.experience}</a>
                                </td>
                              </tr>

                              <tr><td>
                                <MdOutlinePayments className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className="job_biz_text">
                                    {Jobtask.currency} <b>{Jobtask.budget}/- </b>{Jobtask.budgetpackage.replace(/-/g, " ")}
                                  </a>
                                </td>
                              </tr>
                              <tr><td>
                                <CiLocationOn className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'>{Jobtask.city + ", " + Jobtask.state + " - " + Jobtask.country}</a>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div className='job-info'>
                            <table className='experience-table'>
                              <tr><td>
                                <IoDocumentTextOutline className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'> Greetings: {Jobtask.title}</a>
                                </td>
                              </tr>
                              <tr><td>
                                <BsPersonWorkspace className='job_biz_icon' />
                              </td>
                                <td>
                                  <a className='job_biz_text'>{Jobtask.skills}</a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div className='job-save-div' title='Save'>
                          <div className='date-lable'>{GetAgoTime(Jobtask.date_time)}</div>
                          <div className='save_note'>
                            <CiBookmark className='save_icon' />
                            <div className='save_text'>Save</div>
                          </div>
                        </div>

                      </div>
                    ))
                  )}
                </div>

              </div>
              <br /><br />
              <div className="header-title-text" >
                <span className="highlight">Editors</span> — Post Feeds & Skill-Based Stories
              </div><br />
              <div className='feedsUI-grid'>
                {isLoading ? (
                  <Loadingimg />
                ) : feedsData.length === 0 ? (
                  <p>No feeds available.</p>
                ) : (
                  feedsData.map((feeds) => (
                    <div className="feeds-items" onClick={() => navigate('/' + feeds.slug)} key={feeds.id}>
                      <div className="photo-ui-body">
                        <img className="photo-ui-img" src={feeds.file_url} alt="Feed" />
                      </div>
                      <div className='info-div'>
                        <div className='title-text'>{feeds.title.substring(0, 50)}</div>
                        <div className='info-body'>
                          <div className='feed-ui-photo-div'>
                            {feeds.file_url ? (
                              <img src={feeds.userData.photoURL} className='photo-img' />
                            ) : (
                              <Loadingimg />

                            )}
                          </div>
                          <div className='feed-name-div'>
                            <table>
                              <tr><div className='name-text'>{feeds.userData.name.substring(0, 30)}</div></tr>
                              <tr><div className='subscriber-text'>{feeds.userData.subscriber} Subscriber</div>

                              </tr>
                            </table>
                          </div>
                          <div className='view-div'>
                            <div className='view-text'>{NumberFormatter(feeds.views)} Views</div>
                            <div className='view-text'>{NumberFormatter(feeds.like)} Like</div>
                            <div className='date-text'>{GetAgoTime(feeds.date_time)}</div>

                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {UsersData.length > 0 && (
                <div className='post_div row_body'>
                  <br /><br /><br /><br />
                  <div className="header-title-text" id="skills-job-title">
                    <span className="highlight">Skilled Developers and Editors</span> — Hire Now, Get Results Fast
                  </div>
                  <br />
                  <div className="editorsui-grid">
                    {isLoading ? (
                      <Lodinging /> // 🔁 Is this a typo? Should it be <Loading />?
                    ) : (
                      <>
                        {Array.isArray(UsersData) && UsersData.length > 0 ? (
                          UsersData.map((userlist, index) => (
                            <div
                              onClick={() => navigate(`/${userlist.slug}`)}
                              className="editor-items"
                              key={index}
                            >
                              <div className='photo-ui-body' >
                                <div className='cover-ui-div'>
                                  {loading && <div className="loading"><Lodinging /></div>}
                                  <img
                                    className="user-ui-covers-img"
                                    src={userlist.cover}
                                    alt="cover"
                                    onLoad={() => setLoading(false)}
                                    onError={() => setLoading(false)} // also hides loader if there's an error
                                    style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                                  />
                                </div>
                                <div className='photo-ui-div'>
                                  <img
                                    className='photo-ui-img'
                                    src={userlist.photoURL}
                                    alt="User"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = Photosicon;
                                    }}
                                  />
                                </div>
                              </div>
                              <div className='name-div'>
                                <div className='subscriber-btn'><b>{userlist.subscriber}</b> Subscriber</div>

                                <div className="name-text" >
                                  {userlist.name}
                                </div>
                                <div className="bio-text" >
                                  {limitStringLength(userlist.bio, 40)}
                                </div>
                                <br />
                              </div>
                              <div className='editor-div'>
                                <table className='editor-table' >
                                  <tr><td>
                                    <LuBriefcaseBusiness className='eicon' />
                                  </td>
                                    <td>

                                      <td className='iteme-text'>
                                        {`${GetCalculateAge(userlist?.work_experience)} Yrs Experience`}
                                      </td>
                                    </td>
                                  </tr>
                                  <tr><td>
                                    <VscCalendar className='eicon' />
                                  </td>
                                    <td className='iteme-text'>
                                      {`Age: ${GetCalculateAge(userlist?.dob)} Years`}
                                    </td>
                                  </tr>
                                  {/* <tr><td>
                                <MdOutlinePayments className='icon' />
                              </td>
                              <td>
                              {userlist.details.map((detail, index) => (
                                <a className='iteme-text' key={index}>{JSON.stringify(detail)}</a>                                
                              ))}
                             </td>
                               
                              </tr> */}

                                  {userlist.country !== "no" && (
                                    <tr>
                                      <td>
                                        <CiLocationOn className='eicon' />
                                      </td>
                                      <td>
                                        <a className='iteme-text'>{userlist.country}</a>
                                      </td>
                                    </tr>

                                  )}
                                  <tr><td>
                                    <VscCalendar className='eicon' />
                                  </td>
                                    <td className='iteme-text'>
                                      {`Join:  ${GetAgoTime(userlist.datetime)} `}
                                    </td>
                                  </tr>
                                </table>
                              </div>

                              <div className='contact-us-div'>

                                <div className='contact-btn'>
                                  <div className='button-ui'> <BiChat className='icon' /> Contact Us</div>
                                </div>

                              </div>

                            </div>
                          ))
                        ) : (

                          <p>No Developers found.</p>
                        )}
                      </>
                    )}
                  </div>
                </div>

              )}
              <br /><br />
              {/* FetchCategories Skills & Job Categories fetchfategorie_ui.css */}
              <div className="how-it-works">
                <div className="header-title-text" id="skills-job-title">
                  <span className="highlight">Skills & Job Categories</span> — Curated and Organized for Your Success
                </div>
                <br />
                <div className='post-container'>
                  <div className="post_div">
                    <div className='fetchfategorie-ui-grid'>
                      {isLoading ? (
                        <Lodinging /> // Make sure the component name is correct
                      ) : (
                        FetchCategories.map((catlist, index) => (
                          <div key={index} className="fetchfategorie-ui-items">

                            <div className='items-name'>{catlist.skillsData.title}</div>
                            <div className='jobcat-box'>
                              {catlist.jobcat && catlist.jobcat.length > 0 ? (
                                catlist.jobcat.map((j, i) => (
                                  <div key={i} className='items-jobcat'> {j.title} </div>
                                ))
                              ) : (
                                <p>No job category found.</p>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>

              </div>


              <br /><br />
              {/* How it Works Section */}
              <div className="how-it-works">
                <div className="header-title-text">
                  <span className="highlight">How it Works 😊</span> — Simple steps to get started
                </div>

                <div className='Tasks-grid'>
                  {
                    loginisOpen == true ? (
                      <div className="items" onClick={() => navigate(`/account`)}>
                        <FaUser className="item-icon" />
                        <div className='item-div'>
                          <div className="item-text">Manage Profile</div>
                          <div className="items-des">Account Details & set your goals</div>
                        </div>
                      </div>
                    ) : (
                      <div className="items" onClick={() => navigate(`/create-job-profile`)}>
                        <FaUser className="item-icon" />
                        <div className='item-div'>
                          <div className="item-text">Create Profile</div>
                          <div className="items-des">Sign in & set your goals</div>
                        </div>
                      </div>
                    )
                  }

                  <div className="items" onClick={() => navigate(`/skills`)}>
                    <MdOutlineManageSearch className="item-icon" />
                    <div className='item-div'>
                      <div className="item-text">Find Jobs or<br />Post Tasks</div>
                      <div className="items-des">Use smart filters</div>
                    </div>
                  </div>

                  <div className="items" onClick={() => navigate(`/hire-editors`)}>
                    <FaHandsHelping className="item-icon" />
                    <div className='item-div'>

                      <div className="item-text">Connect & Work</div>
                      <div className="items-des">Easy apply or hire</div>
                    </div>

                  </div>
                  <div className="items" onClick={() => navigate(`/task`)}>
                    <BsPersonWorkspace className="item-icon" />
                    <div className='item-div'>
                      <div className="item-text">Freelance Jobs</div>
                      <div className="items-des">Hire Editors and Get Your Tasks Done</div>
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />
              <br /><br />

        
        </div>
      </div>
      <Navbar/>
      <Footer/>
      <WhatsAppQueryPopup/>
    </div>
  );
}
